import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';


@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const modifiedRequest = request.clone({
            setHeaders: {
                'Client-Timezone': timezone,
            },
        });

        return next.handle(modifiedRequest);
    }
}
